import { Component } from 'react';
import { connect } from 'react-redux';
import AuthCloseButton from "@v/auth/components/AuthCloseButton";
import Button from 'shared/Button';
import Email from "@v/member/components/Email";
import PropTypes from "prop-types";
import Spinner from "../../../../shared/Spinner";
import Translation from '@s/Translation';
import { bindActionCreators } from 'redux';

import { isEmail } from '@showclix-shared-util/validators';
import { login, setAuthStarted } from '@/actions/auth'

import request from 'superagent';
import { withNavigation } from '@b/helpers/withNavigation';

class EmailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      emailError: {
        message: ''
      },
      hasError: false,
      emailSubmitted: false,
      isProcessing: true
    };
  }

  onEmailChange = (event) => {
    this.setState({email: event.target.value, emailError: {message: ''}});
  }

  emailSubmit = () => {
    if (!isEmail(this.state.email)) {
      this.setState({emailError: {message: 'checkout__invalid_email_pattern'}});
    } else {
      this.setState({
        isProcessing: true
      }, () => {
        const url = this.props.ui.styleVars.GLOBAL__PARTNER__URL + '/sso/confirmation/send';
        request.post(url)
          .set('Content-Type', 'application/json')
          .send(JSON.stringify({
            'email': this.state.email, 'listing_slug': this.props.listingSlug
          }))
          .then(() => {
            this.setState({
              emailSubmitted: true,
              isProcessing: false
            })
          });
      });
    }
  }

  componentDidMount() {
    if (this.props.referer === 'auth') {
      this.setState({
        isProcessing: false
      })
    } else {
      this.props.setAuthStarted(true);
      const url = this.props.ui.styleVars.GLOBAL__PARTNER__URL + '/sso/confirmation/verify_reservation';
      request.post(url)
        .set('Content-Type', 'application/json')
        .then(res => {
          if ((res.body) && (res.body.success)) {
            this.props.login(res.body.email, res.body.first_name ?? '', res.body.last_name ?? '');

            // Transition
            if (this.props.token) {
              this.props.navigate(`/checkout/${this.props.token}`);
            } else {
              this.props.navigate('/');
            }
          } else {
            this.setState({
              hasError: true
            });
          }
        })
        .catch(() => {
          this.setState({
            hasError: true
          });
        });
    }
  }

  render() {
    return (
      <dialog
        className="tickets--as-overlay tickets-wrap"
        aria-modal="true"
        aria-labelledby='presale-coupon-desc'>
        <div className="tickets">
          <div className="checkout-sso__main-header">
            <div className="checkout-sso__logo-container">
              <img className="checkout-sso__header-image" src={this.props.partner.logo} alt={''}/>
            </div>
            {this.state.hasError && <AuthCloseButton />}
          </div>
          <div className="tickets__content checkout-sso__content">
            {!this.state.emailSubmitted && !this.state.hasError &&
              <div className="text-center">
                {!this.state.isProcessing && <div>
                  <div className="checkout-sso__header">
                    <Translation>{'checkout__enter_your_email_to_continue'}</Translation>
                  </div>
                  <div className='text-center'>
                    <div>
                      <Email
                        email={this.state.email}
                        onEmailChange={this.onEmailChange}
                        required={true}
                        error={this.state.emailError}
                      />
                    </div>
                    <div>
                      <Button onClick={this.emailSubmit} className='button--primary button--sso'>
                        <Translation>{'checkout__continue'}</Translation>
                      </Button>
                    </div>
                  </div>
                </div>}
                {this.state.isProcessing && <div className="inline-block"><Spinner/></div>}
              </div>}
            {this.state.emailSubmitted && <div>
              <div className="checkout-sso__header">
                <Translation>{'checkout__confirmation_link_sent'}</Translation>
              </div>
            </div>}
            {this.state.hasError && <div>
              <div className="checkout-sso__header">
                <Translation>{'checkout__confirmation_error'}</Translation>
              </div>
            </div>}
          </div>
        </div>
      </dialog>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    listingSlug: state.ui.listingSlug,
    partner: state.partner,
    token: state.reservation.token,
    ui: state.ui,
  }
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    login,
    setAuthStarted,
  }, dispatch);
};

EmailContainer.propTypes = {
  partner: PropTypes.object.isRequired,
  listingSlug: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  ui: PropTypes.object.isRequired,
};

EmailContainer.defaultProps = {};
export default withNavigation(connect(mapStateToProps, mapDispatchToProps)(EmailContainer));
